import $ from "jquery";

const myAccountMenu = () => {
  const init = () => {
    action();
  };

  const el = {
    logoEN: ".sax-logo-en",
    logoNL: ".sax-logo-nl",
    logoDE: ".sax-logo-de",
  }

const action = () => {
    let currentURL = window.location.href

    $(document).ready(function () {
        if (currentURL.includes("/en/")) {
            $(el.logoEN).addClass("active");
            $(el.logoNL).removeClass("active");
            $(el.logoDE).removeClass("active");
        } else if(currentURL.includes("/de/")) {
            $(el.logoEN).removeClass("active");
            $(el.logoNL).removeClass("active");
            $(el.logoDE).addClass("active");
        } else {
            $(el.logoEN).removeClass("active");
            $(el.logoNL).addClass("active");
            $(el.logoDE).removeClass("active");
        }
    })

};

  init();
};

try {
  myAccountMenu();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
